import "./base.css";
import "./components/layout/layout.css";
import "./views/home/home.css";
import "./pages/media.css";
import "./pages/pages.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { SiteLayout } from "./components/layout/SiteLayout";
import { I18nProvider } from "./i18n";
import { ContactPage } from "./pages/ContactPage";
import { HistoryPage } from "./pages/HistoryPage";
import { HomePage } from "./pages/HomePage";
import { MapPage } from "./pages/MapPage";
import { MediaPage } from "./pages/MediaPage";
import { MediaViewerPage } from "./pages/MediaViewerPage";
import PrivacyPage from "./pages/PrivacyPage";
import { NotFoundPage } from "./pages/NotFoundPage";

export function App() {
  return (
    <I18nProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/midia/:type/view/:id" element={<MediaViewerPage />} />
          <Route element={<SiteLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/historia" element={<HistoryPage />} />
            <Route path="/mapa" element={<MapPage />} />
            <Route path="/contato" element={<ContactPage />} />
            <Route path="/midia/:type" element={<MediaPage />} />
            <Route path="/privacidade" element={<PrivacyPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </I18nProvider>
  );
}

export default App;
